import { menuAnatomy as parts } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers,
  cssVar,
  defineStyle,
} from '@chakra-ui/styled-system';

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(parts.keys);

const $bg = cssVar('menu-bg');
const $shadow = cssVar('menu-shadow');

const baseStyleList = defineStyle({
  [$bg.variable]: '#fff',
  [$shadow.variable]: 'shadows.2xl',
  _dark: {
    [$bg.variable]: 'rgba(12, 7, 4, 0.96)',
    [$shadow.variable]: '0 24px 70px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(255, 159, 28, 0.18)',
  },
  borderWidth: '0',
  bg: $bg.reference,
  boxShadow: $shadow.reference,
  backdropFilter: 'blur(18px)',
});

const baseStyleItem = defineStyle({
  _focus: {
    [$bg.variable]: 'transparent',
    _dark: {
      [$bg.variable]: 'transparent',
    },
  },
  _hover: {
    [$bg.variable]: 'colors.blue.50',
    _dark: {
      [$bg.variable]: 'rgba(255, 159, 28, 0.10)',
    },
  },
  bg: $bg.reference,
});

const baseStyle = definePartsStyle({
  list: baseStyleList,
  item: baseStyleItem,
});

const Menu = defineMultiStyleConfig({
  baseStyle,
});

export default Menu;
